import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UsersComponent } from './components/team-management/users/users.component';
import { UserFormDialogComponent } from './components/team-management/users/user-form-dialog/user-form-dialog.component';
import { UserDetailDialogComponent } from './components/team-management/users/user-detail-dialog/user-detail-dialog.component';
import { MainSettingsComponent } from './components/main-settings/main-settings.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RolesComponent } from './components/team-management/roles/roles.component';
import { RoleFormDialogComponent } from './components/team-management/roles/role-form-dialog/role-form-dialog.component';
import { TeamsComponent } from './components/team-management/teams/teams.component';
import { TeamFormDialogComponent } from './components/team-management/teams/team-form-dialog/team-form-dialog.component';
import { TeamDetailDialogComponent } from './components/team-management/teams/team-detail-dialog/team-detail-dialog.component';
import { LanguageComponent } from './components/language/language.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { AddRecipientComponent } from './components/add-recipient/add-recipient.component';
import { SettingsSidebarComponent } from './components/settings-sidebar/settings-sidebar.component';
import { UiModule } from 'src/app/ui/ui.module';
// Standalone; not exported by UiModule.
import { AuthErrorBannerComponent } from 'src/app/ui/auth-layout/auth-error-banner.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { MfaEnrolmentWizardComponent } from './components/security-page/mfa-enrolment-wizard/mfa-enrolment-wizard.component';
import { MfaPolicyDialogComponent } from './components/security-page/mfa-policy-dialog/mfa-policy-dialog.component';
import { MfaPolicyPanelComponent } from './components/security-page/mfa-policy-panel/mfa-policy-panel.component';
import { RecoveryCodesPanelComponent } from './components/security-page/recovery-codes-panel/recovery-codes-panel.component';
import { SecurityPageComponent } from './components/security-page/security-page.component';
import { ListCustomFieldsComponent } from './components/list-custom-fields/list-custom-fields.component';
import { AddCustomFieldsComponent } from './components/add-custom-fields/add-custom-fields.component';
import { SmartInboxSettingsComponent } from './components/smart-inbox-settings/smart-inbox-settings.component';
import { SmartRepliesSettingsComponent } from './components/smart-replies-settings/smart-replies-settings.component';
import { ConnectionDetailsModalComponent } from './components/connection-details-modal/connection-details-modal.component';
import { OrdersSettingsComponent } from './components/orders-settings/orders-settings.component';
import { HasPermissionDirective } from 'src/app/shared/has-permission.directive';
import { RolePermissionsDetailComponent } from './components/team-management/roles/role-permissions-detail/role-permissions-detail.component';
import { SplittingRulesListComponent } from './components/splitting-rules-list/splitting-rules-list.component';
import { SplittingRuleDrawerComponent } from './components/splitting-rule-drawer/splitting-rule-drawer.component';
import { TipsSettingsComponent } from './components/tips-settings/tips-settings.component';

@NgModule({
  declarations: [
    UsersComponent,
    UserFormDialogComponent,
    UserDetailDialogComponent,
    MainSettingsComponent,
    RolesComponent,
    RoleFormDialogComponent,
    TeamsComponent,
    TeamFormDialogComponent,
    TeamDetailDialogComponent,
    LanguageComponent,
    NotificationsComponent,
    AddRecipientComponent,
    SettingsSidebarComponent,
    ProfilePageComponent,
    SecurityPageComponent,
    RecoveryCodesPanelComponent,
    MfaPolicyPanelComponent,
    MfaPolicyDialogComponent,
    ListCustomFieldsComponent,
    AddCustomFieldsComponent,
    SmartInboxSettingsComponent,
    SmartRepliesSettingsComponent,
    ConnectionDetailsModalComponent,
    OrdersSettingsComponent,
    RolePermissionsDetailComponent,
    SplittingRulesListComponent,
    SplittingRuleDrawerComponent,
    TipsSettingsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    HasPermissionDirective,
    AuthErrorBannerComponent,
    MfaEnrolmentWizardComponent,
    MatProgressSpinnerModule,
  ]
})
export class SettingsModule { }
